import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { AssignmentTurnedIn, ContentCopy, Delete, LinkOff } from "@mui/icons-material";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ id, data, isConnectable }) => {
  const storage = useNodeStorage();
  const action = type => { storage.setNodesStorage(id); storage.setAct(type); };
  return <div style={{ width: 210, padding: 12, borderRadius: 10, background: "#fff",
    border: "1px solid #dfe7e2", boxShadow: "0 3px 12px #102c2014", fontSize: 12 }}>
    <Handle type="target" position="left" isConnectable={isConnectable} style={{ background: "#087f55" }} />
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
      <strong style={{ display: "flex", alignItems: "center", gap: 5 }}><AssignmentTurnedIn fontSize="small" color="primary" />Criar tarefa</strong>
      <span style={{ display: "flex", gap: 4, cursor: "pointer" }}>
        <ContentCopy fontSize="small" titleAccess="Duplicar" onClick={() => action("duplicate")} />
        <LinkOff fontSize="small" titleAccess="Desconectar" onClick={() => action("disconnect")} />
        <Delete fontSize="small" titleAccess="Excluir" onClick={() => action("delete")} />
      </span>
    </div>
    <div style={{ marginTop: 7, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
      {data?.title || "Clique duas vezes para configurar"}
    </div>
    <small style={{ color: "#718078" }}>Prazo: {data?.dueDays ?? 1} dia(s)</small>
    <Handle type="source" position="right" isConnectable={isConnectable} style={{ background: "#087f55" }} />
  </div>;
});
